import { useEffect, useCallback, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { showMsg } from "../utils/Constants.tsx";

const ONE_HOUR = 60 * 60 * 1000; // 3600000 ms

export const useIdleTimeout = (timeout: any) => {
  const { instance } = useMsal();
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleLogout = useCallback(() => {
    // Limpiar sessionStorage antes de redirigir
    sessionStorage.clear();
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  }, [instance]);

  const resetTimer = useCallback(() => {
    if (!timeout) return; // Si el timeout es null, no hacemos nada
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(handleLogout, timeout);
  }, [handleLogout, timeout]);

  useEffect(() => {
    if (!timeout) return; // No agregar listeners si no hay timeout

    const events = [
      "mousedown",
      "mousemove",
      "keypress",
      "scroll",
      "touchstart",
    ];
    resetTimer();

    events.forEach((event) => window.addEventListener(event, resetTimer));

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [resetTimer, timeout]);
};
